// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getProjectWeeklyCostProgress(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/weekly_progress?cost_based_progress=true`);
}
